<div class="phx-menu-item-main">
  <span *ngIf="phxCondensed" tabindex="-1" class="phx-menu-item-condensed">
    <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
  </span>
  <div *ngIf="!phxCondensed" tabindex="-1" class="phx-menu-item-container">
    <span class="phx-menu-item-content">
      <ng-container *ngTemplateOutlet="defaultContent"></ng-container>
    </span>

    <i *ngIf="hasNestedMenu" class="phx-menu-item-nested-menu-icon" phx-icon [phxIcon]="ChevronRight" [size]="20"></i>
  </div>

  <ng-template #defaultContent>
    <ng-content></ng-content>
  </ng-template>
</div>
<ng-content select="phx-menu"></ng-content>
